import { render, staticRenderFns } from "./BankAccountCreateEdit.vue?vue&type=template&id=3383334a&scoped=true"
import script from "./BankAccountCreateEdit.vue?vue&type=script&lang=js"
export * from "./BankAccountCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383334a",
  null
  
)

export default component.exports